import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { ArrowShortUpSvg } from './ArrowShortUp';

export const ArrowShortUpIcon = createIcon('arrowShortUp', ArrowShortUpSvg);
/**
 * @deprecated используйте ArrowShortUpIcon
 */
export const withArrowShortUpIcon = withIcon('arrowShortUp', ArrowShortUpSvg);
